<template>
  <div class="height" @click="()=>this.associate_list=[]">
      <div class="height flex flex-x flex-y" v-if="loading">
        <div class="loading">
            <div class="flex flex-x">正在获取设备信息...</div>
            <van-skeleton title :row="3"  />
        </div>
      </div>
      <div class="height" v-else>
            <div class="height" :class="{pictures:pictures || history}">
                <div class="header-title flex flex-y">
                        <div class="header-left flex flex-x flex-y" @click="showPopup">
                            <van-icon name="exchange" />
                        </div>
                        <div class="header-centre flex-1"></div>
                        <div class="header-right flex flex-x flex-y" @click="clearData">
                            <van-icon name="plus" />
                        </div>
                </div>
                <div class="gather-box">
                        <div class="id-write flex">
                        <div class="flex-1">姓名：</div>
                        <div class="write_name" v-on:click.stop>
                            <input type="text" v-model="writeName" placeholder="请输入您的姓名"/>
                            <ul class="write_li">
                                <li v-for="item in associate_list" :key="item.id" @click="cell(item)">{{item.name}}</li>
                            </ul>
                        </div>
                        <!-- <vue-chinese placeholder="请输入您的姓名" :inputData="write_name" :inputMot="chineseInput"/> -->
                        </div>
                        <div class="id-write flex">
                        <div class="flex-1">出生日期：</div>
                        <div class="chinese-input" @click="()=>this.picker=true">
                                <span v-if="date">{{date.split(' ')[0]}}</span>
                                <span class="placeholder" v-else>选择出生日期</span>
                        </div>
                        </div>
                        <div class="id-write flex">
                            <div class="flex-1">性别：</div>
                            <div class="sex-input flex flex-y">
                                <van-radio-group v-model="sex" direction="horizontal">
                                    <van-radio name="1">男</van-radio>
                                    <van-radio name="2">女</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="id-write flex">
                        <div class="flex-1">病名：</div>
                        <input type="text" v-model="illness" placeholder="请输入您的病名"/>
                        <!-- <vue-chinese placeholder="请输入您的病名" :inputData="illness" :inputMot="chineseillness"/> -->
                        </div>
                        <div class="id-write flex">
                            <div class="flex-1">舌象：</div>
                            <div class="sex-input flex">
                                <div class="tongue-img flex flex-x flex-y" @click="videoFun">
                                    <van-icon name="photograph" />
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-w">
                            <div class="flex img-1" v-for="(item,index) in image" :key="index">
                                <div class="flex-1"></div>
                                <div @click="()=>imageFun([item])">
                                    <van-image 
                                        width="2rem"
                                        height="2rem"
                                        fit="cover"
                                        :src="item"
                                    />
                                </div>
                                <div class="delete flex flex-y flex-x" @click="()=>{
                                    let ad = spliceFun(image,index);
                                    image = ad;
                                }">
                                    <van-icon name="delete" />
                                </div>
                            </div>
                        </div>
                        <div class="submit-box flex flex-x flex-y">
                            <div class="flex">
                                <div class="submit" @click="saveFun">保存</div>
                                <div v-if="uid" class="history" @click="historyO">历史记录</div>
                                <div v-else class="clear" @click="clearData">清空</div>
                            </div>
                        </div>
                        <div class="equipment_code flex">
                            <div class="flex-1"></div>
                            <div>设备编号：{{code.info.equipment_code}}</div>
                            <div class="offline" @click="linkFun">脱机模式</div>
                        </div>
                </div>
                <van-popup v-model="show" position="left" :style="{ height: '100%' }">
                    <div class="popup-box">
                        <div class="popup-name flex">
                            <input type="text" class="chinese-input" v-model="name_search" placeholder="请输入您的姓名"/>
                            <!-- <vue-chinese placeholder="请输入您的姓名" :inputData="name_search" :inputMot="nameInput"/> -->
                            <div class="search-title flex flex-x flex-y" @click="()=>{
                                if(this.active){
                                    this.page2 = 0;
                                    onLoad2();
                                }else{
                                    this.page1 = 0;
                                    onLoad1();
                                }
                            }">搜索</div>
                        </div>
                        <van-tabs v-model="active">
                            <van-tab title="今日就诊">
                                <van-list
                                    v-model="loading1"
                                    :finished="finished1"
                                    finished-text="没有更多了"
                                    @load="onLoad1"
                                >
                                    <van-cell v-for="item in list1" :key="item.id" :title="item.name" :value="timeSubmit0(item.birthday)" @click="()=>cell(item)" />
                                </van-list>
                            </van-tab>
                            <van-tab title="全部患者">
                                <van-list
                                    v-model="loading2"
                                    :finished="finished2"
                                    finished-text="没有更多了"
                                    @load="onLoad2"
                                >
                                    <van-cell v-for="item in list2" :key="item.id" :title="item.name||item.nikeName" :value="timeSubmit0(item.birthday)" @click="()=>cell(item)" />
                                </van-list>
                            </van-tab>
                        </van-tabs>
                    </div>
                </van-popup>
                <div class="picker-cover" v-if="picker" @click="()=>{this.picker=false}">
                    <div class="picker-bottom" v-on:click.stop >
                        <van-datetime-picker
                            v-model="currentDate"
                            type="date"
                            :formatter="formatter"
                            title="出生年月日"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @cancel="()=>this.picker=false"
                            @confirm="confirmFun"
                            item-height="1rem"
                        />
                    </div>
                </div>
                <div class="wrapper-imgs flex flex-x fle-y" v-if="uploadTotal>0 && !(uploadTotal==upload)">
                    <div class="wrapper" @click.stop>
                        <div class="block" >
                            <div>正在上传本地数据，请等待...</div>
                            <div>上传成功：{{upload}} / {{uploadTotal}}</div>
                            <div v-if="uploadError">上传失败：{{uploadError}}</div>
                            <div class=" flex flex-x" v-if="uploadError && upload+uploadError==uploadTotal">
                                <div class="wrapper-close" @click="closeLocal">关闭</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="video-hot height" :class="{video:pictures}">
                <div class="video-top header-title flex flex-y">
                        <div class="header-left flex flex-x flex-y"></div>
                        <div class="header-centre flex-1"></div>
                        <div class="header-right flex flex-x flex-y" @click="()=>this.pictures=false">
                            <van-icon name="cross" />
                        </div>
                </div>
                <div class="video-box" v-if="pictures">
                    <canvas ref="canvas" style="display: none"></canvas>
                    <div class="videoError" v-if="videoError">{{videoError}}</div>
                    <div v-else class="video-box">
                        <video ref="video" autoplay></video>
                        <div class="video-photo flex flex-x flex-y" @click="photograph" v-if="!photo">
                            <van-icon name="photograph" />
                        </div>
                        <div class="video-photo flex flex-x flex-y" v-else>
                            <van-loading color="#1989fa" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-hot" :class="{card:history}">
                <div class="video-top header-title flex flex-y">
                    <div class="header-left flex flex-x flex-y"></div>
                    <div class="header-centre flex-1"></div>
                    <div class="header-right flex flex-x flex-y" @click="()=>this.history=false">
                        <van-icon name="cross" />
                    </div>
                </div>
                <div class="card-box">
                    <div class="flex flex-w">
                        <div class="flex img-2" v-for="(item,index) in history_list" :key="index" >
                            <div class="img-w">
                                <div @click="()=>imageFun([item.she_img])">
                                    <van-image 
                                        width="100%"
                                        height="3rem"
                                        fit="cover"
                                        :src="item.she_img"
                                    />
                                </div>
                                <div>{{item.bingming}}-{{timeSubmit(item.updatedAt)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapActions , mapState } from 'vuex';
// import vueChinese from "@/components/chinese";
import { ImagePreview , Toast , Dialog } from 'vant';
export default {
  name: 'gather',
  data() {
    return {
      show: false,
      write_name:'',
      name_search:'',
      maxDate:new Date(),
      minDate:new Date(1900, 0, 1),
      currentDate:new Date(1970, 0, 1),
      picker:false,
      date:'',
      sex:'1',
      illness:'',
      active:0,
      list1: [],
      loading1: false,
      finished1: false,
      list2: [],
      loading2: false,
      finished2: false,
      isLoading1: false,
      isLoading2: false,
      uid:0,
      pictures:false,
      videoError:'',
      loading:true,
      image:[],
      page1:0,
      page2:0,
      history:false,
      history_list:[],
      photo:false,
      debounceTimer: null,
      associate_list:[],
      focu:false,
      upload:0,
      uploadTotal:0,
      uploadError:0
    };
  },
  components:{
    //   vueChinese
  },
  created:function(){
      this.deviceFun(this.axiosFun);
  },
  computed:{
        writeName:{
            get() { 
                return this.write_name;
            },
            set(val){
                this.write_name = val;
                if(val){
                    this.debounce(() => {
                        this.associate(val)
                    }, 1000);
                }else{
                    this.associate_list = [];
                }
            }
        },
        ...mapState('device',['code']),
  },
  methods: {
    //防抖
    debounce(func, delay) {
        // 清除之前的定时器
        clearTimeout(this.debounceTimer);
        // 设置新的定时器
        this.debounceTimer = setTimeout(() => {
            func();
        }, delay);
    },
    closeLocal(){
        this.upload = 0;
        this.uploadTotal = 0;
        this.uploadError = 0;
    },
    //上传数据
    localFun(){
        let _this = this;
        let data = window.Android.getAllImageNameList();
        data = JSON.parse(data);
        if(data.code){
            let obj = [];
            data.data.list.map((item)=>{
                item.customers.map((item1)=>{
                    obj.push({
                        ...item1,
                        folderName:item.folderName
                    })
                })
            });
            _this.uploadTotal = obj.length;
            
            obj.map((item2,index)=>{
                setTimeout(() => {
                    let data1 = window.Android.getImageByDateAndName(item2.folderName,item2.cCode);
                    data1 = JSON.parse(data1);
                    if(data1.code){
                        _this.triggerThreeDelays(item2,data1.data.list);
                    }
                }, index * 2000);
            })
        }
    },
    async triggerThreeDelays(item2,imgs){
        let _this = this;
        const promises = [];
        for (let i = 0; i < imgs.length; i++) {
            promises.push(this.delayFunction(imgs[i]));
        }
        const delays = await Promise.all(promises);

        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        this.caijiSubmitData({
            data:{
                sex:Number(item2.gender),
                birthday:item2.birthday,
                name:item2.name,
                bingming:item2.dName,
                she_img:delays,
                companyId:equipment.sys_company_id,
                equipment_code:equipment.equipment_code,
                create_time:`${item2.folderName} ${item2.workTime}`
            },
            fun:()=>{
                //删除这个人的数据
                window.Android.deleteImageContains(item2.folderName,item2.cCode);
                _this.upload = _this.upload+1;
                if(_this.upload==_this.uploadTotal){
                    Toast.success('上传成功！');
                    _this.upload = 0;
                    _this.uploadTotal = 0;
                    _this.uploadError = 0;
                }
            },
            errorfun:()=>{
                _this.uploadError = _this.uploadError+1;
            }
        })
        
    },
    delayFunction(image){
        let _this = this;
        return new Promise((resolve) => {
            _this.ossData({
                base64:`${image}`,
                fun:(img)=>{
                    resolve(img);
                }
            });
        });
    },
    spliceFun(arr,index){
        arr.splice(index, 1);
        return arr;
    },
    //判断设备环境
    deviceFun(axiosFun){
        let device = sessionStorage.getItem('device');
        if(device=='windows'){
            let mac = localStorage.mac;
            if(mac){
                axiosFun(mac);
            }else{
                window.ipcRenderer.send("getMacAddress");
                window.ipcRenderer.on("setMacAddress", (e, msg) => {
                    axiosFun(msg);
                    localStorage.setItem("mac",msg);
                });
            }
        }else if(device=='android'||this.$route.query.mac){
            axiosFun(this.$route.query.mac);
        }
    },
    //获取设备数据
    axiosFun(mac){
        let _this = this;
        this.axiosData({
            data:{mac:mac},
            _this:this,
            return:'gather',
            fun:()=>{
                _this.loading=false;
                //本地数据上传
                this.localFun();
            }
        });
    },
    historyO(){
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(equipment){
            this.historyData({
                data:{
                    user_id:this.uid,
                    companyId:equipment.sys_company_id
                },
                fun:(data)=>{
                    this.history = true;
                    let history_list = []
                    data.list.map((list)=>{
                        list.she_img.map((img)=>{
                            history_list.push({
                                she_img:img,
                                bingming:list.bingming,
                                updatedAt:list.updatedAt
                            });
                        })
                        
                    })
                    this.history_list = history_list;
                }
            })
        }
    },
    cell(e){
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(equipment){
            this.lastHistoryData({
                data:{
                    user_id:e.id,
                    companyId:equipment.sys_company_id
                },
                fun:(data)=>{
                    this.clearData();
                    this.uid = e.id;
                    this.write_name = data.user.name;
                    this.date = this.timeSubmit(data.user.birthday);
                    this.sex = `${data.user.sex}`;
                    this.illness = data.report.bingming;
                    this.associate_list = [];
                    
                    if(data.isToday){
                        this.image = data.report.she_img;
                    }
                    this.show = false;
                }
            });
        }
    },
    showPopup() {
      this.show = true;
      this.active = 0;
    },
    chineseInput(value){
        this.write_name = value;
    },
    chineseillness(value){
        this.illness = value;
    },
    nameInput(value){
        this.name_search = value;
    },
    formatter(type, val) {
        if (type === 'year') {
            return val + '年';
        }
        if (type === 'month') {
            return val + '月';
        }
        if (type === 'day') {
            return val + '日';
        }
        return val;
    },
    confirmFun(value){
        this.date = this.timeSubmit(value);
        this.picker = false;
    },
    timeSubmit(value){
        let date = new Date(value);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        return `${y}-${m}-${d} ${h}:${minute}`;
    },
    timeSubmit0(value){
        let date = new Date(value);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return `${y}-${m}-${d}`;
    },
    onLoad1(){
        this.isLoading1=false;
        this.loading1=true;
        this.finished1 = false;
        this.page1 = this.page1+1;
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(equipment){
            let _this = this;
            this.todayUserData({
                data:{
                    companyId:equipment.sys_company_id,
                    page:this.page1,
                    size:20,
                    name:this.name_search
                },
                fun:(data)=>{
                    this.loading1=false;
                    if(this.page1!==1){
                        _this.list1 = _this.list1.concat(data.list);
                    }else{
                        _this.list1 = data.list;
                    }
                    if(data.total==this.list1.length){
                        this.finished1 = true;
                    }
                }
            })
        }
    },
    onLoad2(){
        this.loading2=true;
        this.isLoading2=false;
        this.finished2 = false;
        this.page2 = this.page2+1;
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(equipment){
            let _this = this;
            this.allUserData({
                data:{
                    companyId:equipment.sys_company_id,
                    page:this.page2,
                    size:20,
                    name:this.name_search
                },
                fun:(data)=>{
                    this.loading2= false;
                    if(this.page2!==1){
                        _this.list2 = _this.list2.concat(data.list);
                    }else{
                        _this.list2 = data.list;
                    }
                    if(data.total==this.list2.length){
                        this.finished2 = true;
                    }
                }
            })
        }
    },
    //输出联想
    associate(val){
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(equipment){
         this.allUserData({
                data:{
                    companyId:equipment.sys_company_id,
                    page:1,
                    size:5,
                    name:val
                },
                fun:(data)=>{
                    this.associate_list = data.list;
                }
            })
        }
    },
    //清空数据
    clearData(){
        this.write_name = '';
        this.date = '';
        this.sex = '1';
        this.illness = '';
        this.image = '';
        this.uid=0;
    },
    imageFun(img){
        ImagePreview({
            images: img,
            closeable: true,
        });
    },
    // 启动H5摄像头
    startUpWebCamera () {
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia ({ audio: false, video: true }).then (stream => {
            this.$refs["video"].srcObject = stream;
          }).then (() => {
            this.$refs["video"].play ();
          }).catch(err => {
            if (err.name === "NotAllowedError") {
                this.videoError = "用户拒绝了权限请求";
            } else if (err.name === "NotFoundError") {
                this.videoError = "未找到可用的摄像头";
            } else if (err.name === "NotSupportedError") {
                this.videoError = "此功能仅支持 HTTPS 环境，请在 HTTPS 环境下运行";
            } else {
                this.videoError = JSON.stringify(err);
            }
          });
        }
    },
    //摄像头
    videoFun(){
        this.pictures = true;
        this.startUpWebCamera();
    },
    //保存
    saveFun(){
        let bool = true;
        if(!this.write_name){
            Toast.fail('请输入姓名！');
            bool = false;
        }
        if(!this.date && bool){
            Toast.fail('请输入生日！');
            bool = false;
        }
        if(!this.sex && bool){
            Toast.fail('请输入性别!');
            bool = false;
        }
        if(!this.illness && bool){
            Toast.fail('请输入病名!');
            bool = false;
        }
        if(!this.image && bool){
            Toast.fail('请输入舌像!');
            bool = false;
        }
        if(bool){
            let equipment = JSON.parse(sessionStorage.getItem('equipment'));
            let _this = this;
            this.caijiSubmitData({
                data:{
                    sex:Number(this.sex),
                    birthday:this.date,
                    name:this.write_name,
                    bingming:this.illness,
                    she_img:this.image,
                    user_id:this.uid,
                    companyId:equipment.sys_company_id,
                    equipment_code:equipment.equipment_code
                },
                fun:()=>{
                    _this.clearData();
                    Toast.success('添加成功！');
                }
            })
        }
    },
    linkFun(){
        Dialog.confirm({
            title: '是否进入脱机模式',
            message: '脱机模式下数据将会存在本机器中，请谨慎选择！',
        })
        .then(() => {
            window.Android.switchWebViewMode(0);
        })
    },
    // 拍照
    photograph() {
        this.photo = true;
        let video = this.$refs.video; // 获取视频元素
        let canvas = this.$refs.canvas; // 获取画布元素
        let ctx = canvas.getContext("2d");

        // 设置画布的宽高，保持视频的宽高比
        const videoAspectRatio = video.videoWidth / video.videoHeight; // 视频的宽高比
        const videoElementAspectRatio = video.offsetWidth / video.offsetHeight; // 视频元素的宽高比

        let canvasWidth = 3600; // 画布的宽度
        let canvasHeight = canvasWidth / videoAspectRatio; // 根据视频宽高比计算画布高度

        // 如果视频元素的宽高比与视频本身不同，需要调整画布大小
        if (videoElementAspectRatio > videoAspectRatio) {
            // 视频元素比视频本身宽，画布高度需要根据视频元素的宽高比调整
            canvasHeight = canvasWidth / videoElementAspectRatio;
        } else {
            // 视频元素比视频本身高，画布宽度需要根据视频元素的宽高比调整
            canvasWidth = canvasHeight * videoElementAspectRatio;
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        // 计算裁剪区域
        let cropX = 0;
        let cropY = 0;
        let cropWidth = video.videoWidth;
        let cropHeight = video.videoHeight;

        if (videoElementAspectRatio > videoAspectRatio) {
            // 视频元素比视频本身宽，裁剪高度
            cropHeight = video.videoWidth / videoElementAspectRatio;
            cropY = (video.videoHeight - cropHeight) / 2;
        } else {
            // 视频元素比视频本身高，裁剪宽度
            cropWidth = video.videoHeight * videoElementAspectRatio;
            cropX = (video.videoWidth - cropWidth) / 2;
        }

        // 绘制裁剪后的视频到画布
        ctx.drawImage(
            video,
            cropX, cropY, cropWidth, cropHeight, // 裁剪区域
            0, 0, canvas.width, canvas.height // 画布区域
        );

        // 导出为图片
        const image = canvas.toDataURL('image/jpeg');        
        let _this = this;
        this.ossData({
            base64:`${image}`,
            fun:(img)=>{
                if(!this.image){this.image=[]}
                this.image.push(img);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                canvas.width = 0;
                canvas.height = 0;
                video.pause();
                video.src = '';
                _this.pictures = false;
                _this.photo = false;
            }
        });
    },
    ...mapActions('device',['axiosData']),
    ...mapActions('gather',['todayUserData','ossData','caijiSubmitData' , 'allUserData','lastHistoryData','historyData'])
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
  @import 'gather';
</style>